module.exports = __webpack_public_path__ + "img/3b.12eb8fd5.png";